import { postAPI, uploadPostAPI } from "../../api/apis";
import { REACT_APP_PROFILE } from "../../utils/common";

export async function submitResume(data: any, id: string | null){
    const Resume = postAPI( REACT_APP_PROFILE + `/resume-details-ext/${id}`, data)
    return Resume
}

export async function extractResume(data: any){
    const Resume = uploadPostAPI( REACT_APP_PROFILE + '/resume-details-ext', data)
    return Resume
}